module.exports = __webpack_public_path__ + "img/savvix_logo_only.00e73ea7.png";